import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Colors from '../../components/Colors';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableContainer: {
      margin: '30px 0 80px',
      padding: '5px 20px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        padding: '0px',
      },
    },
    table: {
      backgroundColor: 'white',
      boxShadow: theme.shadows[1],
    },

    tableHead: {
      backgroundColor: Colors.secundary,
      '& th': {
        color: '#404040',
      },
    },
    buttonsCol: {
      width: 180,
      display: 'flex',
      flexWrap: 'nowrap',
      justifyContent: 'space-between',
    },
    button: {
      borderRadius: 25,
      width: '75px',
      textTransform: 'none',
      padding: '0 5px'
    },
    loadingContainer: {
      display: 'flex',
      marginTop: '30px',
      justifyContent: 'center',
    },
    loadingSpinner: {
      color: Colors.secundary,
    },
    responsive: {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  }),
);
